import ApiService from '../../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

const forEach = require('lodash/forEach');

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            memorialTypes: []
        }
    },
    getters: {
        memorialTypes: (state) => {
            return state.memorialTypes;
        }
    },
    mutations: {
        setMemorialTypes(state, value) {
            window.Vue.set(state, 'memorialTypes', value);
        },
        pushMemorialType(state, value) {
            let memorialTypes = state.memorialTypes;

            memorialTypes.push(value);

            window.Vue.set(state, 'memorialTypes', memorialTypes);
        },
        updateMemorialType(state, value) {
            forEach(state.memorialTypes, (item, key) => {
                if (item.id === value.id) {
                    window.Vue.set(state.memorialTypes, key, value);
                    return;
                }
            });
        },
        removeMemorialType(state, value) {
            let memorialTypes = state.memorialTypes.filter(
                (memorialTypes) => {
                    return value.id !== memorialTypes.id
                }
            );

            window.Vue.set(state, 'memorialTypes', memorialTypes);
        },
    },
    actions: {
        getMemorialTypes({commit}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/memorial-type')
                    .then((response) => {
                        resolve(response);
                        commit('setMemorialTypes', response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        createMemorialType({commit}, memorialType) {
            return new Promise((resolve, reject) => {
                ApiService.post('/memorial-type', memorialType)
                    .then((response) => {
                        resolve(response);
                        commit('pushMemorialType', response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        editMemorialType({commit}, memorialType) {
            return new Promise((resolve, reject) => {
                ApiService.update('/memorial-type/'+memorialType.id, memorialType)
                    .then((response) => {
                        resolve(response);
                        commit('updateMemorialType', response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        deleteMemorialType({commit}, memorial_type) {
            return new Promise((resolve, reject) => {
                ApiService.delete('/memorial-type/' + memorial_type.id)
                    .then((response) => {
                        resolve(response);
                        commit('removeMemorialType', response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }
    }
};
